export default __webpack_public_path__ + "static/bg-491da293822ba3d6209aa3946b06f151.png";